module.exports = "pegasus/assets/themelp1/health/102.png";